import { useCallback, useEffect } from "react";
import { useDocument } from "../../hooks/useDocument";
const FormStylingJS = () => {
    const myDocument = useDocument();
    const shouldFloatLabel = (elem) => {
        const elemChildren = Array.from(elem.children);
        const grandChild = elemChildren[1];
        if (!elemChildren.length || !grandChild || !grandChild.children[0]) {
            return false;
        }
        return Array.from(grandChild.children[0].classList).includes("form-control");
    };
    const inputShouldFloatLabel = (input) => {
        return input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement;
    };
    const hasLabelSiblings = (sibling) => Array.from(sibling.classList).includes("control-label");
    const getLabelSource = (sources) => {
        const sourceIndex = sources.findIndex((source) => Array.from(source).some(hasLabelSiblings));
        return sourceIndex === -1 ? [] : Array.from(sources[sourceIndex]);
    };
    const floatLabels = useCallback(() => {
        const inputs = Array.from(myDocument.getElementsByClassName("form-control"));
        const inputWithFloatingLabels = inputs.filter(inputShouldFloatLabel);
        const textElem = inputWithFloatingLabels.filter((input) => {
            const attribute = input.getAttribute("type");
            return attribute === "text" || attribute === "email" || input instanceof HTMLTextAreaElement;
        });
        textElem.forEach((elem) => {
            const possibleLabelSource = [elem.parentElement.parentElement.children, elem.parentElement.children];
            const labelSource = getLabelSource(possibleLabelSource);
            const label = labelSource.find(hasLabelSiblings);
            if (!label) {
                return;
            }
            const floatLabel = "float-label";
            // float label when default value is present
            if (!!elem.value) {
                label.classList.add(floatLabel);
            }
            // float label when input is focused
            elem.addEventListener("focus", () => {
                label.classList.add(floatLabel);
            });
            // float label is value is truthy, otherwise remove.
            elem.addEventListener("blur", () => {
                if (!!elem.value) {
                    return;
                }
                label.classList.remove(floatLabel);
            });
        });
    }, [myDocument]);
    const wrapListItems = useCallback(() => {
        const listClass = "ktc-list";
        const checkboxList = Array.from(myDocument.getElementsByClassName("ktc-checkbox-list"));
        const radioList = Array.from(myDocument.getElementsByClassName("ktc-radio-list"));
        if (!!checkboxList.length) {
            checkboxList.forEach((item) => item.classList.add(listClass));
        }
        if (!!radioList.length) {
            radioList.forEach((item) => item.classList.add(listClass));
        }
    }, [myDocument]);
    useEffect(() => {
        if (!!myDocument) {
            floatLabels();
            wrapListItems();
        }
    }, [myDocument]);
    // move labels inside form div because we're changing approach to selecting parent elements.
    // we can't use :has for mozilla at the moment so we're moving label arrangement to style it easily.
    useEffect(() => {
        if (!!myDocument) {
            const arr = Array.from(myDocument.getElementsByClassName("form-field"));
            const floatingLabelInputs = arr.filter(shouldFloatLabel);
            floatingLabelInputs.forEach((elem) => {
                if (!!elem.children[0] && !!elem.children[1]) {
                    elem.children[1].appendChild(elem.children[0]);
                }
            });
        }
    }, [myDocument]);
    return null;
};
export default FormStylingJS;
